import * as ApiUrls from "./ApiUrl.SupportRequest";
import { AxiosResponse } from "axios";
import { Support } from "../../Model/Dto/Support/SupportRequest";
import { axiosInstance } from "../AxiosInterceptor";

export const SupportRequestService = {
    SaveTicket: (data:Support.DtoIn ):Promise<AxiosResponse<string>> => axiosInstance.post(ApiUrls.Ticket, data),
    GetById:(id:string):Promise<AxiosResponse<Support.TicketDtoOut>>=> axiosInstance.get(`${ApiUrls.Ticket}${id}`),
    ResolveTicket:(id:string): Promise<AxiosResponse>=>axiosInstance.put(`${ApiUrls.Ticket}${id}/resolve`),
    assignTicket:(id:string): Promise<AxiosResponse>=>axiosInstance.put(`${ApiUrls.Ticket}?id=${id}/assign`),
    sendToDevTeam:(id:string): Promise<AxiosResponse>=>axiosInstance.put(`${ApiUrls.Ticket}?id=${id}/sendToDevTeam`),
    ReactivateTicket:(id:string): Promise<AxiosResponse>=>axiosInstance.put(`${ApiUrls.Ticket}${id}/reactivateTicket`),
    Search:(data:Support.SearchRequest):Promise<AxiosResponse<Support.SearchResponse>> => axiosInstance.post(ApiUrls.TicketSearch, data),
    SaveFeedback:(data:Support.TicketFeedbackDtoIn):Promise<AxiosResponse<number>> => axiosInstance.post(ApiUrls.TicketFeedback,data),
    GetFeeback:(id:number):Promise<AxiosResponse<Support.TicketFeedbackDtoOut>> =>axiosInstance.get(`${ApiUrls.TicketFeedback}/${id}`)
}